module.exports = __webpack_public_path__ + "assets/5b674c887adc2561ec53e840aa88f349.png";